import React from 'react'

function Footer() {
    return (
        <footer className='bg-dark'>
            <div className='container'>
                <span>&copy; 2022 NavEq. All Right Reserved.</span>
            </div>
        </footer>
    )
}

export default Footer